/**
 * Bridge between the Ask AI chat drawer and page-level drawers, so the two
 * never overlap. The Ask AI widget registers its open/close controls here;
 * any page drawer that renders <AskAiReturnBar /> uses them to hand off
 * (close the chat when it opens over it) and hand back ("Back to AI chat").
 *
 * Lives in shared/ because features must not import from each other.
 */
import { create } from 'zustand'

interface AskAiBridgeState {
  /** Whether the Ask AI chat drawer is currently open. */
  chatOpen: boolean
  /** Registered by the Ask AI widget; null until it mounts. */
  openChat: (() => void) | null
  closeChat: (() => void) | null
  setChatOpen: (open: boolean) => void
  registerChatControls: (controls: { openChat: (() => void) | null; closeChat: (() => void) | null }) => void
}

export const useAskAiBridge = create<AskAiBridgeState>((set) => ({
  chatOpen: false,
  openChat: null,
  closeChat: null,
  setChatOpen: (chatOpen) => set({ chatOpen }),
  registerChatControls: ({ openChat, closeChat }) => set({ openChat, closeChat }),
}))
